import { ArchiveBoxIcon, BuildingOffice2Icon, ExclamationTriangleIcon, StarIcon, WrenchIcon } from "@/icons/solid";

export default function CompanyStatusIcon(status) {
	switch (status) {
		case "Setup":
			return WrenchIcon;
		case "Demo":
			return StarIcon;
		case "Archived":
			return ArchiveBoxIcon;
		case "Suspended":
			return ExclamationTriangleIcon;
		default:
			return BuildingOffice2Icon;
	}
}
